import React from 'react';

function Center(props: {children: React.ReactNode}) {
    return (
        <div className="atoms-layouts-center">{props.children}</div>
    );
}

export default Center;
